import React, { useMemo, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useShift, shiftOptionsForDate, shiftOptionsFromIds } from '../../context/ShiftContext';
import { useShiftI18n } from '../../i18n/ShiftI18nContext';
import './shift.css';

/** 登入後選今日班別（員工／主管）；老闆略過 */
export default function ShiftPick() {
  const { user, bizDate, confirmShiftPick, logout, needsShiftPick, isOwner, availableShifts } = useShift();
  const { t } = useShiftI18n();
  const nav = useNavigate();
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');
  const options = useMemo(
    () => (availableShifts?.length ? shiftOptionsFromIds(availableShifts) : shiftOptionsForDate(bizDate)),
    [availableShifts, bizDate],
  );

  useEffect(() => {
    if (isOwner || !needsShiftPick) {
      nav('/shift/home', { replace: true });
    }
  }, [isOwner, needsShiftPick, nav]);

  const pick = async (id) => {
    setErr('');
    setSaving(true);
    try {
      await confirmShiftPick(id);
      nav('/shift/home', { replace: true });
    } catch {
      setErr(t('pick.saveFail'));
    } finally {
      setSaving(false);
    }
  };

  if (isOwner || !needsShiftPick) {
    return <div className="shift-empty">{t('pick.redirect')}</div>;
  }

  return (
        <div className="shift-login-wrap">
          <div>
            <div className="shift-login-title">{t('pick.title')}</div>
            <div className="shift-login-sub">
              {user?.name || ''} · {bizDate || t('common.today')}
              <br />
              {t('pick.hint')}
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {options.map((s) => (
              <button
                key={s.id}
                type="button"
                className={`shift-login-btn shift-pick-${s.id}`}
                disabled={saving}
                onClick={() => pick(s.id)}
                style={{ marginTop: 0 }}
              >
                {t(`shift.${s.id}`)}
              </button>
            ))}
          </div>
          {err && <div className="shift-login-err">{err}</div>}
          <button type="button" className="shift-back-lnk" onClick={logout}>{t('common.logout')}</button>
        </div>
  );
}
